import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_DIRECTUS_URL

export default axios
